import { collection, query, where, getDocs, getDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import axios from 'axios';

const prodBaseUrl = 'https://europe-west2-prod-evc-app.cloudfunctions.net/evc_auth';
const devBaseUrl = 'https://europe-west2-dev-evc-app-4d345.cloudfunctions.net/evc_auth';
const baseUrl = process.env.REACT_APP_ENV !== 'prod' ? devBaseUrl : prodBaseUrl;

export class PortalUsersRepository {
  static async getPortalUsers(pid) {
    try {
      const portalUsersQuery = query(
        collection(db, 'users_charge_portal'),
        where('portfolio', 'array-contains', pid),
      );
      const portalUsersSnapshot = await getDocs(portalUsersQuery);

      const portalUsers = portalUsersSnapshot.docs.map((data) => {
        const userData = data.data();
        return {
          id: data.id,
          email: userData.email,
          firstName: userData.firstName ?? '-',
          lastName: userData.lastName ?? '-',
          accountType: userData.role ?? '-',
          viewableSites: userData.sites ?? [],
          accountStatus: userData.approval,
        };
      });

      return portalUsers;
    } catch (error) {
      throw error;
    }
  }

  static async getPortalUser(userId) {
    const docRef = doc(db, 'users_charge_portal', userId);
    try {
      const portalUsersSnapshot = await getDoc(docRef);
      const portalUser = portalUsersSnapshot.data();
      return {
        id: portalUsersSnapshot.id,
        email: portalUser.email,
        firstName: portalUser.firstName ?? '-',
        lastName: portalUser.lastName ?? '-',
        portalRole: portalUser.role ?? '-',
        viewableSites: portalUser.sites ?? [],
        portalStatus: portalUser.approval,
        portfolios: portalUser.portfolio ?? [],
        firstName: portalUser.firstName ?? '',
        lastName: portalUser.lastName ?? '',
        viewStatements: portalUser.viewStatements ?? false,
      };
    } catch (error) {
      throw error;
    }
  }

  static async requestBlockUser(payload, token) {
    try {
      const response = await axios.post(`${baseUrl}/client_portal/request_user_block`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async requestUpdateUser(payload, token) {
    try {
      const response = await axios.post(`${baseUrl}/client_portal/request_user_update`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
